// extracted by mini-css-extract-plugin
export default {"wrap":"kF-z","fullWidth":"lF-z","hideOnDesktop":"mF-z","content":"nF-z","hasOpenedNav":"oF-z","crumbsList":"pF-z","dropdownsWrap":"qF-z"};